import React, { useState, useRef, useEffect } from 'react';
import { View, Text, TouchableOpacity, Modal, Platform, Image } from 'react-native';
import { MaterialIcons, Feather } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';
//import ActionSheet from '@expo/react-native-action-sheet'
import * as ImagePicker from 'expo-image-picker';
import * as DocumentPicker from 'expo-document-picker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Spinner from 'react-native-loading-spinner-overlay';
import { downloadToFolder } from 'expo-file-dl';

import HeaderDefault from '../../components/HeaderDefault';
import ModalSuccess from "../../components/ModalSuccess";
import { toast } from '../../utils/toast';

import api from '../../services/api';
import styles from './styles';

const IncomeVoucher = () => {
    const [actionSheetVisible, setActionSheetVisible] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [file, setFile] = useState();
    const [dataFile, setDataFile] = useState([]);
    const [loading, setLoading] = useState(false);
    const [updateFile, setUpdateFile] = useState(false);
    const [fileType, setFileType] = useState('');
    const [fileName, setFileName] = useState('');
    const [extensionFile, setExtensionFile] = useState('');

    useEffect(() => {
        (async () => {
            if (Platform.OS !== 'web') {
                const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
                if (status !== 'granted') {
                    alert('Precisamos da sua permissão para acessar os arquivo.');
                }
            }
        })();

        getData();
    }, []);

    const getData = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        setLoading(true);

        api.get('/income-files/details-file', { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                if (res.data.data.length === 0) {
                    setDataFile([]);
                    setLoading(false);
                    console.log('log')
                } else {
                    console.log(res.data.data[0])
                    setFile(res.data.data[0].file.url);
                    setDataFile(res.data.data[0]);

                    setUpdateFile(true);
                    var type = res.data.data[0].file.mime_type.split("/");
                    setFileType(type[0]);
                    setExtensionFile(type[1]);

                    setFileName(res.data.data[0].file.name);
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.log(err)
                toast("Houve um erro ao carregar os dados, tente novamente.", "#DA1414");
                setLoading(false);
            })
    }

    const showActionSheet = () => {
        pickDocument()
    }

    const pickImage = async () => {
        console.log(dataFile.id)
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        let result = await ImagePicker.launchImageLibraryAsync({});

        setLoading(true);

        if (result.cancelled) {
            return setLoading(false);
        }

        let localUri = result.uri;
        let filename = localUri.split('/').pop();

        let match = /\.(\w+)$/.exec(filename);
        let type = match ? `image/${match[1]}` : `image`;

        let formData = new FormData();
        formData.append('file', { uri: localUri, name: filename, type });

        if (updateFile) {
            api.post(`/income-files/${dataFile.id}/replace`, formData, { headers: { "Content-Type": `multipart/form-data; boundary=${formData._boundary}`, 'Authorization': `Basic ${token}` } })
                .then((res) => {
                    setFile(res.data.file.url);
                    var type = res.data.file.mime_type.split("/");
                    setFileType(type[0]);
                    setExtensionFile(type[1]);
                    setFileName(res.data.file.name);
                    setDataFile(res.data);
                    setUpdateFile(true);

                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err)
                    toast("Houve um erro ao salvar os dados, tente novamente.", "#DA1414");
                    setLoading(false);
                })
        } else {
            api.post('/income-files', formData, { headers: { "Content-Type": `multipart/form-data; boundary=${formData._boundary}`, 'Authorization': `Basic ${token}` } })
                .then((res) => {
                    setFile(res.data.file.url);
                    var type = res.data.file.mime_type.split("/");
                    setFileType(type[0]);
                    setExtensionFile(type[1]);
                    setFileName(res.data.file.name);
                    setDataFile(res.data);
                    setUpdateFile(true);
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err)
                    toast("Houve um erro ao salvar os dados, tente novamente.");
                    setLoading(false);
                })
        }
    };

    const pickDocument = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        let result = await DocumentPicker.getDocumentAsync({});

        if (result.cancelled) {
            return false;
        }

        let localUri = "file://" + result.uri;
        let filename = localUri.split('/').pop();

        let match = /\.(\w+)$/.exec(filename);
        let type = match ? `image/${match[1]}` : `image`;

        let formData = new FormData();
        formData.append('file', { uri: localUri.replace(/%/g, '%25'), name: filename, type });

        if (updateFile) {
            setLoading(true);
            api.post(`/income-files/${dataFile.id}/replace`, formData, { headers: { "Content-Type": `multipart/form-data; boundary=${formData._boundary}`, 'Authorization': `Basic ${token}` } })
                .then((res) => {
                    setFile(res.data.file.url);
                    var type = res.data.file.mime_type.split("/");
                    setFileType(type[0]);
                    setExtensionFile(type[1]);
                    setFileName(res.data.file.name);
                    setDataFile(res.data);
                    setUpdateFile(true);
                    setLoading(false);
                })
                .catch(() => {
                    toast("Houve um erro ao salvar os dados, tente novamente.");
                    setLoading(false);
                })
        } else {
            setLoading(true);
            api.post('/income-files', formData, { headers: { "Content-Type": `multipart/form-data; boundary=${formData._boundary}`, 'Authorization': `Basic ${token}` } })
                .then((res) => {
                    setFile(res.data.file.url);
                    var type = res.data.file.mime_type.split("/");
                    setFileType(type[0]);
                    setExtensionFile(type[1]);
                    setFileName(res.data.file.name);
                    setDataFile(res.data);
                    setUpdateFile(true);
                    setLoading(false);
                })
                .catch(() => {
                    toast("Houve um erro ao salvar os dados, tente novamente.");
                    setLoading(false);
                })
        }
    };

    async function downloadFile() {
        if (extensionFile === "pdf") {
            await downloadToFolder(file, 'comprovante.pdf', 'Downloads', 1, {
                notificationType: { notification: 'custom' },
                notificationContent: {
                    downloading: {
                        title: 'Download em progresso...',
                    },
                    finished: {
                        title: 'Download completo!',
                    },
                    error: {
                        title: 'Oops, houve um erro, tente novamente!'
                    },
                },
                downloadProgressCallback: (data) => {
                    setLoading(true);
                    const { totalBytesWritten, totalBytesExpectedToWrite } = data;
                    const pctg = 100 * (totalBytesWritten / totalBytesExpectedToWrite);
                    if (pctg === 100) {
                        setLoading(false);
                        toast("Verifique a sua galeria ou seus arquivos.");
                    }
                },
            });
        } else {
            await downloadToFolder(file, 'comprovante.jpg', 'Downloads', 1, {
                notificationType: { notification: 'custom' },
                notificationContent: {
                    downloading: {
                        title: 'Download em progresso...',
                    },
                    finished: {
                        title: 'Download completo!',
                    },
                    error: {
                        title: 'Oops, houve um erro, tente novamente!'
                    },
                },
                downloadProgressCallback: (data) => {
                    setLoading(true);
                    const { totalBytesWritten, totalBytesExpectedToWrite } = data;
                    const pctg = 100 * (totalBytesWritten / totalBytesExpectedToWrite);
                    if (pctg === 100) {
                        setLoading(false);
                        toast("Verifique a sua galeria ou seus arquivos.");
                    }
                },
            });
        }
    }

    async function sendEmail() {
        setLoading(true);
        console.log(dataFile)

        const token = await AsyncStorage.getItem('JWT_TOKEN');
        api.post('/income-files/send-file', { url: dataFile.file.path }, { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                console.log(res)
                setLoading(false);
                setModalVisible(!modalVisible);
            })
            .catch(() => {
                toast("Houve um erro ao enviar o e-mail, tente novamente.");
                setLoading(false);
            });
    }

    return (
        <>
            <Spinner
                visible={loading}
                textContent={'Carregando...'}
            />
            {/* let optionArray = [
        'Escolher um arquivo', 'Escolher uma imagem', 'Cancelar'
    ]; */}
            {/* <Modal
                visible={actionSheetVisible}
                animationType="slide"
                transparent={true}>
                <View style={styles.modalCenteredView}>
                    <View style={styles.modalView}>
                        <View style={styles.modalText}>
                            <View style={{ flexDirection: "row", justifyContent: 'flex-end' }}>
                                <View>
                                    <MaterialIcons
                                        onPress={() => setActionSheetVisible(!actionSheetVisible)}
                                        name="close"
                                        size={30}
                                        color="black"
                                        style={styles.closeModal}
                                    />
                                </View>
                            </View>
                            <TouchableOpacity onPress={() => { pickDocument() }}><Text>Escolher um arquivo</Text></TouchableOpacity>
                            <TouchableOpacity onPress={() => { pickImage() }}><Text>Escolher uma imagem</Text></TouchableOpacity>
                        </View>
                    </View>
                </View>

            </Modal> */}

            <HeaderDefault title={'Comprovante de renda'} />

            <View style={styles.container}>
                <Text style={styles.description}>Pode ser seu último contra-cheque (holerite) ou o recibo do seu último imposto de renda com seu nome e valor</Text>

                <TouchableOpacity style={styles.btnAdd} onPress={showActionSheet}>
                    <Feather name="plus" size={24} color="black" style={styles.iconAdd} />
                    <Text style={styles.btnText}>Escolher um arquivo</Text>
                </TouchableOpacity>

                {
                    fileType === "image" ? (
                        <Image source={{ uri: file }} style={{ width: 500, height: 500, marginTop: 50, borderRadius: 10, borderWidth: 1 }} />
                    ) : (
                        <Text style={{ fontWeight: 'bold', marginTop: 20 }}>Arquivo: <Text style={{ fontWeight: 'normal' }}>{fileName}</Text></Text>
                    )
                }
            </View>

            <View style={styles.contentBtn}>
                <TouchableOpacity onPress={downloadFile}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.btn}
                    >
                        <Text style={styles.textBtn}>BAIXAR</Text>
                    </LinearGradient>
                </TouchableOpacity>
            </View>



            <Modal
                animationType="fade"
                transparent={false}
                visible={modalVisible}
                statusBarTranslucent={true}
                onRequestClose={() => setModalVisible((visible) => !visible)}
            >
                <ModalSuccess
                    handleCloseModal={() => {
                        setModalVisible(false);
                    }}
                    text={"Seu documento foi enviado com"}
                    textColor={"sucesso!"}
                    img={2}
                    positionHeader={"left"}
                />
            </Modal>
        </>
    );
}

export default IncomeVoucher;